import { Action } from '@ngrx/store';

export const VISIBLE_EOUC = '[OUC_E] VISIBLE';
export const HIDDEN_EOUC = '[OUC_E] HIDDEN';
export const UPDATE_EOUC = '[OUC_E] UPDATE';


export class VPUOXAction implements Action {
  readonly type = VISIBLE_EOUC;
  constructor() {}
}

export class HPUOXAction implements Action {
  readonly type = HIDDEN_EOUC;
  constructor() {}
}
export class UPUOXAction implements Action {
  readonly type = UPDATE_EOUC;
  constructor() {}
}

export type PaEOUCActions =
    | VPUOXAction
    | HPUOXAction
    | UPUOXAction;